import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { BookingsPage } from "@/features/bookings/BookingsPage";

const search = z.object({
  tab: z.enum(["pages", "upcoming", "past", "cancelled"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/bookings/")({
  validateSearch: search,
  component: () => <BookingsPage search={Route.useSearch()} />,
});
